import moment from "moment";

export const isMobile = ()=>{
    return window.innerWidth <= 1320;
}

export const isDesktop = ()=>{
    return window.innerWidth > 1024;
}

export const modalHeight  = "92%";